<template>
  <div v-loading="loading" style="padding: 20px">
    <div v-if="prescriptionInfo">
      <warehouse-vet-prescription-card
        :vetPrescriptionInfo="prescriptionInfo"
        :vetPrescriptionItemList="prescriptionItemList"
      />
    </div>
    <el-empty v-else-if="!loading" :description="errorMsg" :image-size="100">
      <el-button v-if="errorMsg" @click="fetchList" size="small"> 重新加载 </el-button>
    </el-empty>
  </div>
</template>

<style lang="less" scoped>
.item-count {
  padding: 5px 10px;
  background-color: #f1f1f1;
  margin-bottom: 20px;
  color: #444444;

  .status-label {
    margin-right: 5px;
    font-weight: bolder;
    color: #000000;
  }

  .count-label {
    color: #000000;
    float: right;
  }
}

.order-service-title {
  color: #919191;
  margin-bottom: 10px;
}

.order-item-title {
  color: #919191;
  margin-top: 30px;
  margin-bottom: 10px;
}

.order-item {
  .item-remark {
    font-weight: bolder;
    color: #e87431;
  }
}
</style>

<script>
import warehouseVetPrescriptionCard from "../../../../components/business/warehouseVetPrescriptionCard.vue";

export default {
  components: {
    warehouseVetPrescriptionCard,
  },
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    defaultParams() {
      return {
        storeGuid: this.pageParams.storeGuid,
        orderGuid: this.pageParams.guid,
        autoIssue: 1,
      };
    },
    pageParams() {
      return Object.assign({}, (this.$route && this.$route.params) || {}, this.params);
    },
    pageQuery() {
      return Object.assign({}, (this.$route && this.$route.query) || {}, this.query);
    },
  },
  data() {
    return {
      loading: false,
      errorMsg: null,
      prescriptionInfo: null,
      prescriptionItemList: null,
    };
  },
  methods: {
    fetchList() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.errorMsg = null;
      return this.requestApi(
        "biz.warehouse.vet.prescription.info.detailByOrder",
        this.defaultParams
      )
        .then((resp) => {
          return this.requestApi("biz.warehouse.vet.prescription.item.list", {
            prescriptionGuid: resp.data.guid,
            storeGuid: resp.data.storeGuid,
          }).then((itemResp) => {
            this.prescriptionInfo = resp.data;
            this.prescriptionItemList = itemResp.data.list || [];
          });
        })
        .then(() => {
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.errorMsg =
            (err && err.msg) || (err && err.message) || "连接服务器失败，请检查网络";
        });
    },
  },
  mounted() {
    this.fetchList();
  },
};
</script>
